var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('gen-search-widget',{attrs:{"configId":"595fa43e-bcd8-45cf-9107-07e457490310","triggerId":"searchWidgetTrigger"}}),_c('button',{staticClass:"button",attrs:{"id":"searchWidgetTrigger"}},[_vm._v("Google Search")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }